// Telemetry for trackpad/wheel bugs we can't reproduce in dev. Sentry-only —
// these are latent UX bugs, not product-analytics events, so they don't belong
// in Mixpanel. Sentry's captureMessage groups by message string, giving us one
// issue per bug type with an event count and timeline.

import * as Sentry from '@sentry/react';

const BACK_NAV_WINDOW_MS = 500;

let lastHorizontalWheelAt = 0;
let lastDeltaX = 0;
let lastDeltaY = 0;
let listenerInstalled = false;

export const trackZoomJump = (props: {
	prev: number;
	next: number;
	ratio: number;
	deltaY: number;
	ctrlKey: boolean;
	metaKey: boolean;
}) => {
	Sentry.captureMessage('Zoom jump detected', {
		level: 'warning',
		extra: props,
	});
};

// Correlates a recent horizontal-dominant wheel event with a pagehide — the
// signature of Chrome/Arc's swipe-to-go-back overriding our pan. Heuristic:
// can't observe the nav itself after unload.
export const recordHorizontalWheel = (deltaX: number, deltaY: number) => {
	lastHorizontalWheelAt = performance.now();
	lastDeltaX = deltaX;
	lastDeltaY = deltaY;
};

export const installBackNavMonitor = () => {
	if (listenerInstalled) return;
	listenerInstalled = true;

	window.addEventListener('pagehide', () => {
		if (lastHorizontalWheelAt === 0) return;
		const msSinceGesture = performance.now() - lastHorizontalWheelAt;
		if (msSinceGesture < BACK_NAV_WINDOW_MS) {
			Sentry.captureMessage('Back nav suspected after horizontal wheel gesture', {
				level: 'warning',
				extra: { lastDeltaX, lastDeltaY, msSinceGesture },
			});
		}
	});
};
